import { AGENT_API_URL, API_URL, INITIAL_TOKEN } from "../config/config";

export const api_urls = {
  base_url: API_URL,
  agent_base_url: AGENT_API_URL,
  service_token: INITIAL_TOKEN,
  login: "login",
  forgotPassword: "forgot-password",
  changePassword: "change-password",
  agentLogin: "login",
  /** POST `forgot-password` on `AGENT_API_URL` (`/api/agent/forgot-password`). */
  agentForgotPassword: "forgot-password",
  dashboard: "dashboard",
  allUsers: "all-users",
  userById: (id) => `all-users/${id}`,
  /** PATCH body e.g. `{ is_blocked: true }` — `api/admin/update-user/:id` */
  updateUser: (id) => `update-user/${id}`,
  getAgents: "agents",
  createAgent: "create-agent",
  getAgent: (id) => `get-agent/${id}`,
  deleteAgent: (id) => `agents/${id}`,
  appointments: "appointment",
  appointmentById: (id) => `appointment/${id}`,
  appointmentComplete: (id) => `appointment/${id}/complete`,
  appointmentCancel: (id) => `appointment/${id}/cancel`,
  invoices: "invoice",
  services: "service",
  serviceById: (id) => `service/${id}`,
  faqs: "faqs",
  faqById: (id) => `faqs/${id}`,
  location: "location",
  locationById: (id) => `location/${id}`,
  /** Admin: `/api/admin/...` */
  quoteRequests: "quote-request",
  quoteRequestFinalize: (id) => `quote-request/${id}/finalize`,
  quoteRequestCancel: (id) => `quote-request/${id}/cancel`,
  /** GET `/api/admin/quotes/{id}/prepare` — extra artist/quote detail */
  quotePrepare: (id) => `quotes/${id}/prepare`,
  /** Agent: `/api/agent/quote-request` */
  agentQuotes: "quote-request",
  agentQuoteFinalize: (id) => `quote-request/${id}/finalize`,
  agentQuoteCancel: (id) => `quote-request/${id}/cancel`,
  /** GET `/api/agent/quotes/{id}/prepare` — agent variant */
  agentQuotePrepare: (id) => `quotes/${id}/prepare`,
  artistShopApprove: (id) => `artist-shop/${id}/approve`,
  artistShopReject: (id) => `artist-shop/${id}/reject`,
  /** GET `user-shop?is_approved=1&user_id={id}` — empty data[] means not yet approved */
  userShop: (userId) => `user-shop?is_approved=1&user_id=${userId}`,
  notifications: "notifications",
  getUnreadCount: "get-unread-count",
  markAllRead: "mark-all-read",
  markSingleRead: (id) => `mark-single-read/${id}`,
  wallet: "wallet",
  walletUsers: "wallet/users",
  walletTransactions: "wallet/transactions",
  walletSettings: "wallet/settings",
  analyticsEarnings: "analytics/earnings",
  analyticsUsers: "analytics/users",
  analyticsAppointments: "analytics/appointments",
};
